<template>
  <b-row no-gutters class="table-row test">
    <!-- Draft Case Index -->
    <b-col class="p-1" cols="1">{{index + 1}}.</b-col>
    <!-- Draft Case Details -->
    <b-col :class="{'read-only' : requiresLocaleSwitch}" class="p-1">
      <!-- TODO i18n -->
      <b-row no-gutters class="result-header justify-content-md-left">
        <b-col class="content-cont">
          <b-link href="#" class="content-heading" @click.prevent="draftCase.caseId != -1 ? compareDraftCase() : restoreNewCase()">
            <!-- solution title -->
            <span :class="solutionTitleClass" name="solution-title" v-html="solutionTitle"/>
          </b-link>
        </b-col>
      </b-row>
      <!-- draft body -->
      <b-row no-gutters class="result-body justify-content-md-left">
        <!-- solution name or new solution indicator -->
        <b-col class="name mr-2" cols="4" md="auto">{{$t('lable.solutionID')}}:</b-col>
        <b-col v-if="caseInfo.caseName" class="value mr-3" cols="7" md="auto">{{caseInfo.caseName}}</b-col>
        <b-col v-else class="value" cols="7" md="auto">{{$t('kvs.structure.new')}}</b-col>
        <!-- solution status -->
        <b-col class="name mr-2" cols="4" md="auto">{{$t('label.status')}}</b-col>
        <b-col class="value mr-3" cols="7" md="auto">{{$t('label.draft.$')}}</b-col>
        <!-- solution author -->
        <b-col class="name mr-2" cols="4" md="auto">{{$t('label.authorName')}}:</b-col>
        <b-col class="value mr-3" cols="7" md="auto">{{draftCase.userName}}</b-col>
        <!-- solution modification date -->
        <b-col class="name mr-2" cols="4" md="auto">{{$t('krop.slot.case-modification-date')}}:</b-col>
        <b-col class="value" cols="7" md="auto">{{caseInfo.modificationDate}}</b-col>
      </b-row>
      <b-row no-gutters class="result-header justify-content-md-left">
        <b-col class="content-cont">
          <!-- requires locale switch -->
          <span class="error" v-if="requiresLocaleSwitch" v-html="requiresLocaleSwitchMessage"/>
        </b-col>
      </b-row>
    </b-col>
    <!-- Delete Draft Case Details -->
    <b-col cols="1" class="p-2">
      <!-- ------------------- delete draft --------------------------- -->
      <b-link @click.prevent="deleteDraftCase()">
        <b-icon-x-octagon-fill variant="danger"/>
      </b-link>
    </b-col>
  </b-row>
</template>

<script>
//---- components ---------
//---- mixins -------------
//---- services -----------
import DraftService from "@/app/services/draft.service.js";
import NotificationService from "@/app/services/notification";
//---- 3rd-parties --------
import { BIconXOctagonFill } from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
  components: {
    BIconXOctagonFill,
  },

  props: [
    "index",
    "draftCase"
  ],

  computed: {

    draftId() {
      return this.draftCase.id;
    },

    caseInfo() {
      return JSON.parse(this.draftCase.draftCaseInfo);
    },

    requiresLocaleSwitch() {
      return this.draftCase.hasDifferentLocale;
    },

    requiresLocaleSwitchMessage() {
      if (this.solutionLocale)
        return 'You need to switch your language to ' + this.solutionLocale.caption + ' to recover this unsaved changes.';
      return 'The language for this solution (' + this.draftCase.locale + ') is no longer available. Please contact your administrator.'
    },

    solutionLocale() {
        return this.locales.find(locale => locale.code === this.draftCase.locale);
    },

    solutionTitle() {
      if (!this.caseInfo.title)
        return this.$t('solutions.nosolution') 
      return this.caseInfo.title;
    },

    solutionTitleClass() {
        return !this.caseInfo.title ? 'title-link blank-title' : 'title-link';
    },

    ...mapGetters({
      locales: "header/locales",
    })
  }, // end computed

  
  methods: {
    // delete the draft case
    async deleteDraftCase() {
      await DraftService.deleteDraftCase({draftId: this.draftId});
      NotificationService.info(this.$t('draft.deleted'));
      this.$emit('reload-drafts');
    }, // end deleteDraftCase()

       // view the draft case for existing case in comparison mode
    compareDraftCase() {
      DraftService.viewDraftCase({draftId: this.draftId}).then(() => {
        this.$bvModal.hide("case-draft-modal-list");
        this.$store.state.draft.openedDraftId = this.draftId;
        this.safeRouterPush({
          path: "/draft-comparison",
          hash: "draftId=" + this.draftId
        });
      });
    }, // end compareDraftCase()

    // restore the draft for new case
    async restoreNewCase() {
      const response = await DraftService.restoreDraftForNewCase({draftId: this.draftId});
      if (response.data) {
          this.$bvModal.hide("case-draft-modal-list");
          this.$store.state.draft.openedDraftId = this.draftId;
          this.authoring();
      }
    }, // end restoreNewCase()

    // load the authoring screen
    async authoring() {
      let response = await this.$store.dispatch("authoring/authoring");
      if (response.data) {
        this.safeRouterPush("/solution-modify");
        this.$emit('reload-drafts');
      }
    }, // end authoring()

  }, // end methods

}
</script>

<style>
.result-header {
  color: #acacac;
  font-size: 0.9rem;
}
.result-body {
  color: #acacac;
  font-size: 0.9rem;
}
.value {
  color: #7c7c7c;
  padding-right: 7px;
}
.blank-title {
  color: red; /* fallback for IE */
  color: var(--error-color);
}
.read-only {
  background-color: lightgray;
  pointer-events: none;
}
.modal-body-padding {
  padding-top: 0% !important;
}
.title-link {
  padding-right: 7px;
  font-weight: 400;
}
.title-link >>> p {
  padding: 0rem !important;
  margin: 0rem !important;
  display: inline;
}

</style>